module.exports = __webpack_public_path__ + "static/media/minus.44d20197.svg";